import { Reveal } from './Reveal';

const FEATURES = [
  { title: 'High Delivery Rates', icon: '/landing/icon-goal.png', bg: '#dfe8fe', desc: 'Our intelligent routing ensure your messages get delivered-fast and reliably.' },
  { title: 'Secure & Compliant', icon: '/landing/icon-shield.png', bg: '#e9f8ed', desc: 'Enterprise-grade security and full compliance with global data protection standards.' },
  { title: 'Real-time Analytics', icon: '/landing/icon-barchart.png', bg: '#efecfc', desc: 'Track performance in real-time and make data-driven decisions that grow your business.' },
  { title: '24/7 Expert Support', icon: '/landing/icon-headset.png', bg: '#feeae4', desc: 'Our support team is always available to help you succeed at any time.' },
];

export function WhyChooseSection() {
  return (
    <section style={{ maxWidth: 1400, margin: '0 auto', padding: '80px 24px' }}>
      <Reveal>
        <h2 style={{ margin: '0 auto 12px', textAlign: 'center', maxWidth: 600, fontFamily: 'Inter, sans-serif', fontWeight: 800, fontSize: 32, color: '#152752', lineHeight: 1.15 }}>
          Why businesses choose Sleengshort
        </h2>
        <p style={{ margin: '0 auto 56px', textAlign: 'center', maxWidth: 590, fontFamily: 'Inter, sans-serif', fontWeight: 500, fontSize: 16, color: '#4c5876', lineHeight: 1.5 }}>
          We help you communicate better, so you can focus on what matters most.
        </p>
      </Reveal>

      <div style={{ display: 'flex', gap: 32, flexWrap: 'wrap', justifyContent: 'center' }}>
        {FEATURES.map((f, i) => (
          <Reveal key={f.title} delay={i * 0.08} style={{ flex: '1 1 230px', maxWidth: 260 }}>
            <Reveal delay={i * 0.08} y={0} rotate={i % 2 === 0 ? -18 : 18} scale={0.7} style={{ width: 70, height: 74, borderRadius: 10, background: f.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 24 }}>
              <img src={f.icon} alt={f.title} width={50} height={50} style={{ objectFit: 'contain' }} />
            </Reveal>
            <p style={{ margin: '0 0 10px', fontFamily: 'Inter, sans-serif', fontWeight: 700, fontSize: 16, color: '#000' }}>{f.title}</p>
            <p style={{ margin: 0, fontFamily: 'Inter, sans-serif', fontWeight: 500, fontSize: 14, color: '#4c5876', lineHeight: 1.4 }}>{f.desc}</p>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
